'use client';

var SUCCESS_CODE = 200;

export { SUCCESS_CODE };
//# sourceMappingURL=constant.js.map
